import React from 'react'

function KeywordSkill(props) {
  return (
    <div className="keyword">
        {props.name}
    </div>
  );
}

export default KeywordSkill;